import { createRoute } from '@tanstack/react-router';

import { AdminBaseRouteLayout } from '$/routes/Admin/AdminBaseRouteLayout';

export const AdminAiPromptsRoute = createRoute({
  getParentRoute: () => AdminBaseRouteLayout,
  path: '/admin/aiPrompts',
}).lazy(() => import('./AdminAiPromptsRoute.lazy').then((d) => d.Route));
